import { Moment } from "moment";
import Utils from "../utils";
import { SyncModel, SyncDataModel, DataModel } from "./syncModel";

// Requests
export class BlackWhiteListSyncModel extends SyncModel {
}

// Responses
export class BlackWhiteListDeviceDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  public blocked: boolean;
  public manufacturer: string;
  public model: string;
  public showmodel: string;
  public platform: string;
  public version_device: string;
  public version_app: string;
  public description_de: string;
  public description_en: string;
  public deleted: boolean;
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public change_by: number;
}

export class BlackWhiteListSyncDataModel extends SyncDataModel {
  public devices: BlackWhiteListDeviceDataModel[];
  public get models(): DataModel[] { return this.devices; }
  public DeserializeType(): void {
    this._DeserializeType(BlackWhiteListDeviceDataModel);
  }
}
